import { useState, useEffect } from 'react';
import { useQuery } from 'data-fetching-client';
import FormattedMessage from 'I18n/components/FormattedMessage';
import SelectionPanel from 'automation-ui-canvas/create/SelectionPanel';
import useWorkflowTypePQLs from 'automation-ui-enrollment/components/workflowType/hooks/useWorkflowTypePQLs';
import { SEARCH_WORKFLOWS } from 'automation-ui-canvas/create/queries/workflowQueries';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function WorkflowSelectionPanel({
  setObjectTypeId,
  onClose,
  stagedTriggerOption,
  onSelectTriggerOption
}) {
  var _data$searchWorkflows, _data$searchWorkflows2;
  const [searchTerm, setSearchTerm] = useState('');
  const [searchOffset, setSearchOffset] = useState(0);
  const [allOptions, setAllOptions] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const {
    loading: pqlsLoading,
    isLocked,
    shouldSelectObjectType,
    CustomModal,
    onCloseCustomModal
  } = useWorkflowTypePQLs();
  const [primaryObjectTypeId] = stagedTriggerOption.supportedObjectTypeIds;
  const {
    data
  } = useQuery(SEARCH_WORKFLOWS, {
    variables: {
      query: searchTerm,
      offset: searchOffset,
      objectTypeId: primaryObjectTypeId
    }
  });
  const hasMore = (_data$searchWorkflows = data === null || data === void 0 ? void 0 : data.searchWorkflows.hasMore) !== null && _data$searchWorkflows !== void 0 ? _data$searchWorkflows : false;
  const nextOffset = Number((_data$searchWorkflows2 = data === null || data === void 0 ? void 0 : data.searchWorkflows.offset) !== null && _data$searchWorkflows2 !== void 0 ? _data$searchWorkflows2 : 0);
  useEffect(() => {
    const results = data === null || data === void 0 ? void 0 : data.searchWorkflows.results;
    if (results) {
      var _data$searchWorkflows3;
      const newOptions = ((_data$searchWorkflows3 = data === null || data === void 0 ? void 0 : data.searchWorkflows.results) !== null && _data$searchWorkflows3 !== void 0 ? _data$searchWorkflows3 : []).map(({
        properties: {
          hs_name: {
            value: text
          },
          hs_flow_id: {
            value
          },
          hs_object_type_id: {
            value: objectTypeId
          }
        }
      }) => ({
        text,
        value,
        objectTypeId,
        locked: isLocked(objectTypeId)
      }));
      const startIndex = nextOffset - results.length;
      setAllOptions(currentOptions => currentOptions.slice(0, startIndex).concat(newOptions));
      setIsLoading(false);
    }
  }, [data, nextOffset, isLocked]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [CustomModal && /*#__PURE__*/_jsx(CustomModal, {
      onClose: onCloseCustomModal
    }), /*#__PURE__*/_jsx(SelectionPanel, {
      heading: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "createWorkflow.workflowSelectionPanel.title"
      }),
      options: pqlsLoading ? [] : allOptions,
      loading: pqlsLoading || isLoading,
      hasMore: hasMore,
      loadMore: () => {
        setSearchOffset(nextOffset);
        setIsLoading(true);
      },
      searchTerm: searchTerm,
      onSearchTermChange: newSearchTerm => {
        setSearchTerm(newSearchTerm);
        setSearchOffset(0);
        setAllOptions([]);
        setIsLoading(true);
      },
      onClose: onClose,
      onSelectOption: ({
        value,
        objectTypeId
      }) => {
        if (shouldSelectObjectType(objectTypeId)) {
          onSelectTriggerOption(Object.assign({}, stagedTriggerOption, {
            filters: [{
              filterType: 'PROPERTY',
              property: 'hs_flow_id',
              operation: {
                propertyType: 'enumeration',
                operator: 'IS_ANY_OF',
                includeObjectsWithNoValueSet: false,
                operationType: 'enumeration',
                operatorName: 'IS_ANY_OF',
                values: [value]
              }
            }]
          }));
          setObjectTypeId(objectTypeId);
        }
      }
    })]
  });
}